var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WaitlistCard',{attrs:{"feature":"automated payment recovery service","onWaitlist":!!_vm.dunningWaitlist,"signupAction":_vm.DUNNING_WAITLIST_SIGNUP}})}
var staticRenderFns = []

export { render, staticRenderFns }